import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCookieStore = defineStore('cookie', () => {
  const canLoadChat = ref(false)

  function initFromStorage() {
    try {
      const consent = localStorage.getItem('kali-cookie-consent')
      // O chat tem consentimento próprio, separado do de cookies — qualquer
      // decisão já tomada sobre cookies (aceitar, rejeitar ou personalizar)
      // libera o chat, não só "aceitar". Sem isso, quem rejeita cookies
      // nunca via o chat carregar de novo nesta sessão.
      const decided = ['accepted', 'rejected', 'custom'].includes(consent)
      const closed = sessionStorage.getItem('kali-banner-closed') === 'true'
      if (decided || closed) {
        canLoadChat.value = true
        const eventName = decided
          ? (consent === 'accepted' ? 'cookies-accepted' : 'cookies-rejected')
          : 'banner-closed'
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent(eventName))
        }, 0)
      }
    } catch (e) {
      console.warn('[useCookieStore] Falha ao ler flags de consentimento:', e)
    }
  }

  function enable(source) {
    if (!canLoadChat.value) {
      canLoadChat.value = true
      setTimeout(() => window.dispatchEvent(new CustomEvent(source)), 0)
    }
  }

  return { canLoadChat, initFromStorage, enable }
})
